import { useState } from "react";
import { countries } from "../../global/countriesAndSources";
import { addIgo, setIgoLogo } from "../../HTTP/countries";

export default function AddIgo() {

  const localUser = JSON.parse(localStorage.getItem("user"))
    if (!localUser.super_admin && localUser.admin_access !== 5) {
        window.location.href = '/'
    }

    const [formData, setFormData] = useState({
        name: '',
        label: '',
        link: '',
        country_list: '',
        image : null
    });

    // États pour la recherche de pays
    const [countrySearch, setCountrySearch] = useState('');
    const [filteredCountries, setFilteredCountries] = useState(countries);

    // Fonction pour formater le texte (minuscules et tirets au lieu d'espaces)
    const formatText = (text) => {
        return text.toLowerCase().replace(/\s+/g, '-');
    };

    // Filtrer les pays en fonction de la recherche
    const filterCountries = (searchTerm) => {
        if (searchTerm.trim() === '') {
            setFilteredCountries(countries);
        } else {
            const filtered = countries.filter(country =>
                country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                country.code.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredCountries(filtered);
        }
    };

    const handleCountrySearchChange = (e) => {
        const searchValue = e.target.value;
        setCountrySearch(searchValue);
        filterCountries(searchValue);
    };

    // Obtenir les pays sélectionnés pour l'affichage
    const getSelectedCountries = () => {
        const selectedCodes = formData.country_list.split(',').filter(Boolean);
        return countries.filter(country => selectedCodes.includes(country.code));
    };

    // Effacer la recherche
    const clearSearch = () => {
        setCountrySearch('');
        setFilteredCountries(countries);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        
        // Mettre à jour le champ modifié
        const updatedFormData = {
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        };
        
        // Si c'est le champ label qui est modifié, on vérifie si le nom correspond au format du label
        // Si oui, on continue à mettre à jour le nom automatiquement
        if (name === 'label') {
            const formattedLabel = formatText(value);
            // On vérifie si le champ nom est vide OU s'il correspond au format du label précédent
            // Si c'est le cas, on continue à mettre à jour automatiquement le champ nom
            if (formData.name === '' || formData.name === formatText(formData.label)) {
                updatedFormData.name = formattedLabel;
            }
        }
        
        setFormData(updatedFormData);
        console.log(updatedFormData);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Mise à jour des données sans l'image
            const formwithoutImage = {
                name: formData.name,
                label: formData.label,
                link: formData.link,
                country_list: formData.country_list,
            };
            
            const res = await addIgo(formwithoutImage);
            console.log("res", res);
            
            // Vérifier si res est vraiment un succès (selon votre API)
            if (res) {
                // Si une image est présente, la télécharger
                if (formData.image) {
                    console.log("Image à télécharger", formData.image);
                    const res2 = await setIgoLogo(res.result, formData.image);
                    console.log("res2", res2);
                    if (res2) {
                        console.log("Image téléchargée avec succès");
                        alert('Igo added successfully with image');
                    } else {
                        // Ne pas rediriger en cas d'échec du téléchargement d'image
                        alert("Erreur lors de l'ajout de l'image");
                        return; // Empêcher la redirection
                    }
                } else {
                    alert('Igo added successfully without image');
                }
                window.location.href = "/admin/igo";
            } else {
                alert("Erreur lors de la modification de l'organisation");
            }
        } catch (error) {
            console.error("Erreur lors de la modification de l'organisation:", error);
            alert("Erreur lors de la modification de l'organisation");
        }
    };

    return (
        <div className="mt-8 max-w-md mx-auto p-6 bg-white rounded-lg shadow-md md:overflow-y-auto" style={{ maxHeight: window.innerWidth >= 768 ? 'calc(100vh - 100px)' : undefined }}>
            <h2 className="text-2xl font-bold mb-6 text-center">Ajouter une organisation</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label htmlFor="label" className="block text-gray-700 text-sm font-bold mb-2">
                        Label :
                    </label>
                    <input
                        type="text"
                        name="label"
                        id="label"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={handleChange}
                        value={formData.label}
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="name" className="block text-gray-700 text-sm font-bold mb-2">
                        Nom : <span className="text-xs text-gray-500">(Automatiquement formaté sans majuscules ni espaces)</span>
                    </label>
                    <input
                        type="text"
                        name="name"
                        id="name"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={handleChange}
                        value={formData.name}
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="link" className="block text-gray-700 text-sm font-bold mb-2">
                        Lien vers le site officiel :
                    </label>
                    <input
                        type="text"
                        name="link"
                        id="link"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={handleChange}
                        value={formData.link}
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="country_list" className="block text-gray-700 text-sm font-bold mb-2">
                        Liste des pays :
                    </label>
                    
                    {/* Champ de recherche */}
                    <div className="mb-3 relative">
                        <input
                            type="text"
                            placeholder="Rechercher un pays..."
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            value={countrySearch}
                            onChange={handleCountrySearchChange}
                        />
                        {countrySearch && (
                            <button
                                type="button"
                                onClick={clearSearch}
                                className="absolute right-2 top-2 text-gray-400 hover:text-gray-600"
                            >
                                ✕
                            </button>
                        )}
                    </div>
                    

                    
                    {/* Liste des pays avec checkboxes */}
                    <div className="max-h-48 overflow-y-auto border border-gray-300 rounded-md p-2">
                        {filteredCountries.length === 0 ? (
                            <div className="text-gray-500 text-center py-4">
                                Aucun pays trouvé pour "{countrySearch}"
                            </div>
                        ) : (
                            filteredCountries.map((country) => (
                                <div key={country.code} className="flex items-center mb-2">
                                    <input
                                        type="checkbox"
                                        id={`country-${country.code}`}
                                        name="country_list"
                                        value={country.code}
                                        checked={formData.country_list.split(',').includes(country.code)}
                                        onChange={(e) => {
                                            const selectedCountries = formData.country_list.split(',').filter(Boolean);
                                            if (e.target.checked) {
                                                selectedCountries.push(country.code);
                                            } else {
                                                const index = selectedCountries.indexOf(country.code);
                                                if (index > -1) {
                                                    selectedCountries.splice(index, 1);
                                                }
                                            }
                                            setFormData({ ...formData, country_list: selectedCountries.join(',') });
                                        }}
                                        className="mr-2"
                                    />
                                    <label htmlFor={`country-${country.code}`} className="text-gray-700 cursor-pointer flex-1">
                                        {country.name} <span className="text-gray-400 text-sm">({country.code})</span>
                                    </label>
                                </div>
                            ))
                        )}
                    </div>
                    
                    {/* Affichage des pays sélectionnés - toujours visible et en bas */}
                    <div className="mt-3 p-2 bg-blue-50 rounded-md">
                        <div className="text-sm font-medium text-blue-800 mb-1">
                            Pays sélectionnés ({getSelectedCountries().length}) :
                        </div>
                        <div className="flex flex-wrap gap-1">
                            {getSelectedCountries().length === 0 ? (
                                <span className="text-blue-600 text-sm italic">Aucun pays sélectionné</span>
                            ) : (
                                getSelectedCountries().map((country) => (
                                    <span
                                        key={country.code}
                                        className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800"
                                    >
                                        {country.name}
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const selectedCountries = formData.country_list.split(',').filter(Boolean);
                                                const index = selectedCountries.indexOf(country.code);
                                                if (index > -1) {
                                                    selectedCountries.splice(index, 1);
                                                }
                                                setFormData({ ...formData, country_list: selectedCountries.join(',') });
                                            }}
                                            className="ml-1 text-blue-600 hover:text-blue-800"
                                        >
                                            ✕
                                        </button>
                                    </span>
                                ))
                            )}
                        </div>
                    </div>
                </div>
                <div className="mb-4">
                    <label htmlFor="image" className="block text-gray-700 text-sm font-bold mb-2">
                        Image :
                    </label>
                    <input
                        type="file"
                        name="image"
                        id="image"
                        accept="image/*"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })}
                    />
                    {
                        formData.image && typeof formData.image === 'string' ? (
                            // Show the existing image from the server
                            <img
                                src={'http:'+formData.image}
                                alt="Preview"
                                className="mt-2 w-full h-auto rounded-md"
                            />
                        ) : formData.image instanceof File ? (
                            // Show the new file that was just uploaded
                            <img
                                src={URL.createObjectURL(formData.image)}
                                alt="Preview"
                                className="mt-2 w-full h-auto rounded-md"
                            />
                        ) : null
                    }
                </div>
                <div className="flex items-center justify-end">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    >
                        Enregistrer
                    </button>
                </div>
            </form>
        </div>
    );
}